import React, { CSSProperties } from "react";

// Function to calculate CSS properties for an event
const EventCSSProperties = (
  start: number, // Start position of the event
  span: number, // Span or duration of the event (not used here)
  marginTop: number, // Top margin for the event
  cellWidth: any // Width of a single cell
): CSSProperties => {
  return {
    top: marginTop, // Set the top margin
    left: `${(start - 1) * cellWidth}px`, // Calculate the left position
    width: `${cellWidth}px`, // Set the width of the event
    zIndex: 2, // Set the stacking order
  };
};

export default EventCSSProperties;
